import { IRegion } from './types/region';

export function emailIsValid(email: string): boolean {
  const pattern = /.+@.+\..+/gi;

  return pattern.test(email);
}

export function getRegionById(regions: IRegion[], id: number): IRegion {
  return regions.filter(region => region.id === id)[0];
}

export function decodeHtml(text: string): string {
  return text.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
}

export function scrollTop() {
  window.scrollTo(0, 0);
}
